export default __webpack_public_path__ + "static/media/ttweb-mobile.4081e7d9.png";